module.exports = __webpack_public_path__ + "assets/close-black-bf498b.svg";